// Components==============
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button/Button';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import Input from 'components/UI/Form/Input';
import Textarea from 'components/UI/Form/Textarea';
import TrainingCollapseCard from 'components/UI/TrainingCollapseCard/TrainingCollapseCard';
import { useTranslate } from 'hooks/useTranslate';
import { TrainingBuilderContext } from 'pages/Workspace/TrainingBuilder/TrainingBuilder';
import React, { useContext, useEffect, useRef, useState } from 'react';
import './SessionCard.module.scss';
// =========================

export default function SessionCard() {
  const {
    currentSession,
    training,
    setSessions,
    sessions,
    handleDeleteSession,
    handleAddSessionImage,
    handleDeleteSessionImage,
  } = useContext(TrainingBuilderContext);

  const translate = useTranslate();

  const sessionIdList = training?.sessions
    ?.sort((a, b) => (a.order_index || 0) - (b.order_index || 0))
    .map((s) => s.id);

  const currentIdIndex = sessionIdList?.indexOf(currentSession || 0) || 0;

  const labelRef = useRef<HTMLLabelElement>(null);

  function handleTitleChange(e: React.ChangeEvent<HTMLInputElement>) {
    setSessions((prev) =>
      prev.map((s) =>
        s.id === currentSession
          ? { ...s, title: e.target.value, changed: true }
          : s
      )
    );
  }

  function handleDescriptionChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    setSessions((prev) =>
      prev.map((s) =>
        s.id === currentSession
          ? { ...s, description: e.target.value, changed: true }
          : s
      )
    );
  }

  const image = sessions.find((session) => session.id === currentSession)
    ?.image;

  const [resizeTrigger, setResizeTrigger] = useState(false);
  useEffect(() => setResizeTrigger((prev) => !prev), [currentSession]);

  return (
    <TrainingCollapseCard
      left={
        <div styleName="top">
          <Input
            ext_onChange={handleTitleChange}
            ext_formValue={
              sessions.find((s) => s.id === currentSession)?.title || ''
            }
            color={image ? 'outline-white' : 'grey'}
            placeholder={translate('general.terms.title')}
            name=""
          />
          {image ? (
            <FontAwesomeIcon icon={faTrash} onClick={handleDeleteSession} />
          ) : (
            <CircleButton
              icon={faTrash}
              color="grey"
              onClick={handleDeleteSession}
            />
          )}
        </div>
      }
      sessionIndex={currentIdIndex + 1}
      background={image}
      editMode
    >
      <>
        <div styleName="description">
          <Textarea
            ext_formValue={
              sessions.find((s) => s.id === currentSession)?.description || ''
            }
            ext_onChange={handleDescriptionChange}
            color={image ? 'outline-white' : 'grey'}
            placeholder={translate('general.terms.description')}
            name=""
            resizeTrigger={resizeTrigger}
          />
        </div>
        {!image && (
          <p styleName="image-text">
            {translate('course.descriptions.background-image')}
          </p>
        )}
        <input
          type="file"
          id="upload-btn"
          onChange={(e) => handleAddSessionImage(e)}
          name="upload"
          styleName="upload"
        />
        {image ? (
          <div styleName="button-wrapper">
            <Button color="white" onClick={handleDeleteSessionImage}>
              {translate('course.terms.delete-image')}
            </Button>
            <label htmlFor="upload-btn" ref={labelRef}>
              <Button
                onClick={() =>
                  labelRef.current ? labelRef.current.click() : undefined
                }
              >
                {translate('course.terms.change-image')}
              </Button>
            </label>
          </div>
        ) : (
          <div styleName="button-wrapper">
            <label htmlFor="upload-btn" ref={labelRef}>
              <Button
                color="grey"
                onClick={() =>
                  labelRef.current ? labelRef.current.click() : undefined
                }
              >
                {translate('course.terms.session-image')}
              </Button>
            </label>
          </div>
        )}
      </>
    </TrainingCollapseCard>
  );
}
